import React from 'react';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import Link from '@material-ui/core/Link';
import { useLocation } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faHouseUser } from '@fortawesome/free-solid-svg-icons';
import { faImagePolaroid, faSquareSlidersVertical, faBoreHole } from '@fortawesome/pro-solid-svg-icons';

export const MainListItems = () => {
  const location = useLocation();
  const currentPath = location.pathname;

  const isActive = (path) => currentPath === path;

  return (
    <div className='custom-menu'>
      <Link href="/dashboard" className='menu-links'>
        <ListItem button selected={isActive('/dashboard')}>
          <ListItemIcon>
            <FontAwesomeIcon icon={faHouseUser} alt='Dashboard' title='Dashboard' className='MuiSvgIcon-root'/>
          </ListItemIcon>
          <ListItemText primary="Dashboard" />
        </ListItem>
      </Link>
      <Link href="/my-drill-templates" className='menu-links'>
        <ListItem button selected={isActive('/my-drill-templates')}>
          <ListItemIcon>
            <FontAwesomeIcon icon={faBoreHole} alt='Drill Templates' title='Drill Templates' className='MuiSvgIcon-root'/>
          </ListItemIcon>
          <ListItemText primary="Drill Templates" />
        </ListItem>
      </Link>
      <Link href="/my-uv-print-templates" className='menu-links'>
        <ListItem button selected={isActive('/my-uv-print-templates')}>
          <ListItemIcon>
            <FontAwesomeIcon icon={faImagePolaroid} alt='UV Print Templates' title='UV Print Templates' className='MuiSvgIcon-root'/>
          </ListItemIcon>
          <ListItemText primary="UV Print Templates" />
        </ListItem>
      </Link>
      <Link href="/my-box-configurations" className='menu-links'>
        <ListItem button selected={isActive('/my-box-configurations')}>
          <ListItemIcon>
            <FontAwesomeIcon icon={faSquareSlidersVertical} alt='Box Job Templates' title='Box Job Templates' className='MuiSvgIcon-root'/>
          </ListItemIcon>
          <ListItemText primary="Box Job Templates" />
        </ListItem>
      </Link>
    </div>
  );
};